import React from 'react'

function KeynoteView({keynoteId}) {
    return (
        <div>
            
        </div>
    )
}

export default KeynoteView
